import React from "react";
import "./QuestionareForm.css";
import RadioInput from "../radioInput/RadioInput";

const QuestionareForm = ({ allQuestions, allAnswers, handleAnswer, isInError, setMainArea }) => {
  var checkForAnswer = Object.keys(allAnswers).length;

  if (checkForAnswer > 0) {
    isInError = false;
  }

  var allowedAreas = ["Lower back", "Shoulder", "Knee", "Thigh", "Hip"];

  var areaID = {
    "Lower back": 1,
    Shoulder: 4,
    Knee: 5,
    Thigh: 6,
    Hip: 7
  };

  return (
    <div className={isInError ? "formContainerError" : "formContainer"}>
      {allQuestions &&
        allQuestions.sections &&
        allQuestions.sections.map(
          (section, key) =>
            key === 0 && (
              <>
                {section.title && (
                  <div key={key} className="formTitle">
                    {section.title}
                  </div>
                )}
                {section.questions.map((question, q) => (
                  <div key={q}>
                    <div className={isInError && !allAnswers[question.question_id] && !question.is_optional ? "formSubtitleError" : "formSubtitle"}>{(question.question ? question.question_number + ". " : "") + question.question}</div>
                    {question.answers.map((answer, a) => (
                      <div key={a} onClick={() => {
                        if ( allowedAreas.indexOf(answer.name) > -1 ) {
                          handleAnswer(question.question_id, answer.name, section.questions);
                          setMainArea(areaID[answer.name]);
                        } ;
                      }} style={{ opacity: allowedAreas.indexOf(answer.name) > -1 ? 1 : 0.6 }}>
                        <RadioInput
                          isChecked={allAnswers && allAnswers[question.question_id] && allAnswers[question.question_id] === answer.name ? true : false}
                          isInError={isInError && !allAnswers[question.question_id] && allowedAreas.indexOf(answer.name) > -1}
                          textValue={answer.name}
                          checkRadio={() => {
                            return;
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </>
            )
        )}
    </div>
  );
};

export default QuestionareForm;
